import { Button, Col, Form, Input, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import { MdClose } from "react-icons/md";

import "./PostToInternet.css";

function PostToInternet({ setIsConfirmationBoxOpen }) {
  return (
    <div className="post-to-internet-container">
      <div className="post-to-internet">
        <MdClose
          className="close"
          onClick={() => setIsConfirmationBoxOpen(false)}
        />
        <h2>Please Update Required Fields</h2>
        <Row gutter={[0, 16]}>
            <Col span={24}>
                {/* Message box  */}
            </Col>
            <Col span={24}>
                <Row className="header-row">
                    <Col span={8}><span>Field Name</span></Col>
                    <Col span={16}><span>Link to Edit</span></Col>
                </Row>
                <Row className="colored-data">
                    <Col span={8}><span>Available On</span></Col>
                    <Col span={16}><span className="onclick-text">Enter an available on date</span></Col>
                </Row>
                <Row className="data-row">
                    <Col span={8}><span>Occupied</span></Col>
                    <Col span={16}><span className="onclick-text">Set a move-out date</span></Col>
                </Row>
            </Col>
            <Col span={24}>
                <Form labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                colon={false}>
                    <Form.Item label="Marketing Title">
                        <Input />
                    </Form.Item>
                    <Form.Item label="Marketing Description">
                        <TextArea rows={3} />
                    </Form.Item>
                </Form>
            </Col>
            <Col span={24} className="buttons">
                <Row gutter={[6,0]}>
                    <Col><Button type="primary" onClick={() => setIsConfirmationBoxOpen(false)}>Save and Post</Button></Col>
                    <Col><Button onClick={() => setIsConfirmationBoxOpen(false)}>Post Anyway</Button></Col>
                    <Col><Button onClick={() => setIsConfirmationBoxOpen(false)}>Cancel</Button></Col>
                </Row>
            </Col>
        </Row>
      </div>
    </div>
  );
}

export default PostToInternet;